import React from 'react'

import CategoryItems from './CategoryItems';
import {
  CategoryWrapper,CategoryListStyle
} from "./styles";




const CategoryList = ({ id,categorydata,setProducts }) => {

  
  return (
    <CategoryWrapper>
    
      <CategoryListStyle>
     {categorydata && categorydata.map((res,index) => (
         <CategoryItems 
           id={id}
           key={res.id}
            res={res}
           ind={index}
          setProducts={setProducts}
          />
        
      ))}
       
      </CategoryListStyle>
    </CategoryWrapper>
  )
}

export default CategoryList
